import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updateBlog } from "./buttonActionApi";
import { updateBlogData } from "../blog/blogSlice";
import { updateBlogsData } from "../blogs/blogsSlice";

const initialState = {
  blog: {},
  isLoading: false,
  isError: false,
  error: "",
};

// async thunk
export const updateBlogInfo = createAsyncThunk(
  "buttonAction/updateButtonAction",
  async (blog, thunkAPI) => {
    const responseBlog = await updateBlog(blog);
    thunkAPI.dispatch(updateBlogData(responseBlog));
    // thunkAPI.dispatch(updateBlogsData(responseBlog));
    return responseBlog;
  }
);

const buttonActionSlice = createSlice({
  name: "buttonAction",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(updateBlogInfo.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(updateBlogInfo.fulfilled, (state, action) => {
        // console.log(action.payload)
        state.isLoading = false;
        state.blog = action.payload;
      })
      .addCase(updateBlogInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.blog = {};
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default buttonActionSlice.reducer;
